import { createAction, props } from '@ngrx/store';
import { QueryParams } from '../../modals/QueryParams';
import { Reward } from '../../modals/user.reward';

export const userRewardRequested = createAction(
    '[USER_REWARD] User Reward Requested',
    props<{ queryParams: QueryParams }>()
);

export const userRewardLoaded = createAction(
    '[USER_REWARD] User Reward Loaded',
    props<{ userReward: Reward[], hasNextPage: boolean, isLoaded: boolean }>()
);

export const userRewardLoading = createAction(
    '[USER_REWARD] User Reward Loading',
    props<{ isLoading: boolean }>()
);

export const userRewardResetRequested = createAction(
    '[USER_REWARD] User Reward Reset Requested'
);

export const userRewardResetCompleted = createAction(
    '[USER_REWARD] User Reward Reset Completed',
    props<{ userReward: Reward[], hasNextPage: boolean }>()
);

export const userRewardLoadingError = createAction(
    '[USER_REWARD] User Reward Loading Error',
    props<{ errorMessage: string }>()
);

export const rewardAllowedRequested = createAction(
    '[USER_REWARD] Reward Allowed Requested'
);

export const rewardAllowedLoaded = createAction(
    '[USER_REWARD] Reward Allowed Loaded'
);
